import { Component, EventEmitter, Input, Output } from '@angular/core'
import { WorkspaceSummary } from '@helios/state-management'

@Component({
  selector: 'hs-workspace-category',
  templateUrl: './workspace-category.component.html',
  styleUrls: ['./workspace-category.component.scss'],
})
export class WorkspaceCategoryComponent {
  @Input() title?: string
  @Input() workspaces?: WorkspaceSummary[] | null
  @Input() isPreset?: boolean
  @Input() defaultWorkspacePrefix?: string
  @Output() cloneWorkspace = new EventEmitter<string>()

  expanded = true
}
